import {TasksService2} from "../../services/tasks-service2.service";
import {Actions, createEffect, Effect, ofType} from "@ngrx/effects";
import {Store} from "@ngrx/store";
import {IAppState} from "../../state/app.state";
import {ETasksActions, GetTasksList, GetTasksListFailure, GetTasksListSuccess} from "../../actions/tasks/tasks.actions";
import {catchError, map, mapTo, switchMap, withLatestFrom} from "rxjs/operators";
import {of} from "rxjs";
import {ITask} from "../../models/tasks/tasks.interface";
import {LoadAuthenticatedUser} from "../../actions/security/authenticated-user.actions";
import {Injectable} from "@angular/core";

@Injectable()
export class TasksListEffects {
  TasksList$ = createEffect( ()=>this._actions$.pipe(
    ofType<GetTasksList>(ETasksActions.GetTasksList),
    withLatestFrom(this._store$),
    switchMap(([action,storeState]) => {
        return this._tasksService.getTasksList(storeState.authentication.data.accessToken, storeState.applicationParameters)
          .pipe(
            map(
              result =>{
                console.log('GetTasksList effect');
                console.log(result);
                const taskList:Array<ITask> = [];
                result['report'].forEach((item) =>{
                  const task:ITask = {
                    rid: item['ID'],

                    partyId: storeState.applicationParameters.selectedDatasourcePartyId,
                    partyName: '',

                    dateSubmited: item['DateSubmited'], //В формате DD.MM.YYYY
                    dateStarted: item['DateStarted'], //В формате DD.MM.YYYY
                    dateExecuted: item['DateExecuted'], //В формате DD.MM.YYYY

                    statusCode: item['Phase'],
                    errorCode: item['Status'],
                    url: item['URL'],
                    fileType: '',

                    operationCode: item['OprCode'],
                    operationName: item['OprName'],

                    description: item['OprParams'], //item['Description'],
                    operationProfile: item['profile']

                  };
                  taskList.push(task);
                });

                return new GetTasksListSuccess(taskList);

              }
            ),
            catchError(error => {
              console.log(error);
              return of(new GetTasksListFailure());
            })

          );
      }
    )
  ));

  constructor(
    private _tasksService: TasksService2,
    private _actions$: Actions,
    private _store$: Store<IAppState>
  ) {}

}

